var _rect, _path, _path2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFile = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 42.48,
    height: 42.48,
    rx: 2.85,
    fill: "#F2F5F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0003 9.33203H22.167L30.3337 17.4987V30.332C30.3337 30.9509 30.0878 31.5444 29.6502 31.9819C29.2127 32.4195 28.6192 32.6654 28.0003 32.6654H14.0003C13.3815 32.6654 12.788 32.4195 12.3504 31.9819C11.9128 31.5444 11.667 30.9509 11.667 30.332V11.6654C11.667 11.0465 11.9128 10.453 12.3504 10.0154C12.788 9.57786 13.3815 9.33203 14.0003 9.33203Z",
    stroke: "#033156",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.167 9.33203V17.4987H30.3337",
    stroke: "#033156",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 42.48,
    height: 42.48,
    rx: 2.85,
    stroke: "#C4C4C4",
    strokeWidth: 0.3
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/file.0ffea69a4e5f367e796f14397cd98656.svg";